import { Component } from '@angular/core';
import {
  PersonDetailsFacadeService,
  UpdatePersonData,
} from '@qivos/qivoscloud-ion-components';
import { PersonDetailsForm } from '@qivos/qivoscloud-ion-components/lib/models/person-details.model';
import {
  Address,
  Consent,
  Email,
  Person,
  QivosCloudService,
} from '@qivos/qivoscloud-ng-api';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    public PersonFacade: PersonDetailsFacadeService,
    public qcService: QivosCloudService
  ) {}

  person = new Person();

  personDetails: PersonDetailsForm = {
    mobileNumber: {
      rendered: false,
      required: false,
      disabled: false,
      label: 'Κινητό',
      placeholder: '',
      value: '',
      validation: /^69[0-9]*\d*$/,
      message: '',
    },
    gender: {
      rendered: true,
      required: true,
      label: 'Φύλο',
      maleGenderLabel: 'Άνδρας',
      femaleGenderLabel: 'Γυναίκα',
      otherGenderLabel: 'Άλλο',
      value: { Name: '', Value: '' },
    },
    firstName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Όνομα',
      placeholder: 'Πληκτρολογήστε το Όνομα',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    lastName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Επώνυμο',
      placeholder: 'Πληκτρολογήστε το Επώνυμο',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    email: {
      rendered: true,
      required: false,
      label: 'email',
      placeholder: 'Πληκτρολογήστε το email',
      value: '',
      validation:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    region: {
      rendered: true,
      required: false,
      label: 'Νομός',
      placeholder: 'Επιλέξτε Νομό',
      value: '',
      message: '',
    },
    town: {
      rendered: true,
      required: false,
      label: 'Πόλη',
      placeholder: 'Πληκτρολογήστε την Πόλη;',
      value: '',
    },
    addressLine: {
      rendered: false,
      required: false,
      disabled: true,
      label: '',
      message: '',
      placeholder: '',
      validation: / /,
      value: ''
    },
    zipCode: {
      rendered: true,
      required: false,
      label: 'Τ.Κ',
      placeholder: 'Πληκτρολογήστε τoν Ταχυδρομικό Κώδικα',
      value: '',
      validation: /^[0-9]{5}$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    dateOfBirth: {
      rendered: true,
      required: false,
      label: 'Ημερομηνία γέννησης',
      placeholder: 'Επιλέξτε την Ημερομηνία Γέννησης',
      datePickerDoneButtonLabel: 'ΟΚ',
      datePickerCancelButtonLabel: 'ΆΚΥΡΟ',
      value: '',
      minValue: 18,
      maxValue: 95,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    nameDate: {
      rendered: true,
      required: false,
      nameDateDayPlaceholder: 'Επιλέξτε την Ημέρα',
      nameDateMonthPlaceholder: 'Επιλέξτε τον Μήνα',
      nameDateLabel: 'Ημερομηνία ονομαστικής εορτής',
      nameDateDayValue: '',
      nameDateDayLabel: 'Ημέρα',
      nameDateMonthValue: '',
      nameDateMonthLabel: 'Μήνας',
      errorMessage: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    singleConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    smsConsent: {
      rendered: false,
      label: '',
      value: false,
      name: '',
    },
    viberConsent: {
      rendered: false,
      label: '',
      value: false,
      name: '',
    },
    emailConsent: {
      rendered: false,
      label: '',
      value: false,
      name: '',
    },
    multiConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    allConsent: {
      rendered: false,
      label: '',
      value: false,
    },
    isPersonalized: true,
    flowExecution: true,
    flowExecutionId: 'ENVIE_LMF_TRIGGER_FROM_PERSONALIZED_FORM',
    flowExecutionSubject: 'LOYALTY_MEMBER',
    token: '',
  };

  register() {
    if (this.PersonFacade.email.length > 0) {
      this.person.emailList?.push(
        new Email({ emailAddress: this.PersonFacade.email, isPrimary: true })
      );
    }

    if (this.PersonFacade.selectedRegionCode.length > 0) {
      this.person.addressList?.push(
        new Address({
          addressLine2: '',
          addressType: 'PRIMARY_PERSON_ADDRESS',
          town: this.PersonFacade.selectedTown,
          regionCode: this.PersonFacade.selectedRegionCode,
          countryCode: 'gr',
          postCode: this.PersonFacade.zipCode,
        })
      );
    }

    if (this.PersonFacade.multiConsentsStatus === false) {
      if (this.PersonFacade.smsConsent === true) {
        this.person.consentList?.push(
          new Consent({
            name: 'SMS',
            flag: true,
          })
        );
      }

      if (this.PersonFacade.emailConsent === true) { 
        this.person.consentList?.push(
          new Consent({
            name: 'EMAIL',
            flag: true,
          })
        );
      }

      if (this.PersonFacade.viberConsent === true) {
        this.person.consentList?.push(
          new Consent({
            name: 'VIBER',
            flag: true,
          })
        );
      }
    }

    if (this.PersonFacade.multiConsentsStatus === true) {
      this.person.consentList?.push(
        new Consent({
          name: 'SMS',
          flag: true,
        }),
        new Consent({
          name: 'EMAIL',
          flag: true,
        }),
        new Consent({
          name: 'VIBER',
          flag: true,
        })
      );
    }

    this.person.firstName = this.PersonFacade.firstName;
    this.person.lastName = this.PersonFacade.lastName;
    this.PersonFacade.gender.Value === 'UNKNOWN'
      ? (this.person.salutationCode = 'DEFAULT')
      : (this.person.salutationCode = this.PersonFacade.gender.Value);
    this.person.gender = this.PersonFacade.gender.Value;
    this.person.dateOfBirth = this.PersonFacade.dateOfBirth;
    this.person.nameDayDay = this.PersonFacade.nameDateDay;
    this.person.nameDayMonth = this.PersonFacade.nameDateMonth;
    this.person.QCCode = this.PersonFacade.qcCode;

    this.PersonFacade.dispatch(UpdatePersonData({ person: this.person }));
  }
}
